import { ActionFunction } from 'react-router-dom'

import { formDataToArray } from '@utils/actions'
import ApiRoutes from '@utils/api-routes'
import http from '@utils/http'

const removeFavoritesAction: ActionFunction = async ({ request }) => {
  const formData = await request.formData()
  const externalIds = formDataToArray(formData.get('scoreIds'))

  if (!externalIds.length) {
    return null
  }

  return http.action.post<RemoveFavoritesResponse>(ApiRoutes.apiFavoritesRemoveScoresPath(), {
    score_ids: externalIds,
  })
}

export default removeFavoritesAction

export type RemoveFavoritesResponse = {
  failed: string[]
  scores: string[]
}
